

export const veoHowto = {
    title: '如何生成电影级 AI 视频',
    subtitle: '三步完成：使用关键帧、多参考图与原生音频，生成高品质视频。',
    steps: [
      { num: '1', title: '建立项目：关键帧或参考图', body: '输入详细提示或上传图片。使用关键帧控制起始/结尾，或多图保持风格一致。' },
      { num: '2', title: '设置高级参数', body: '开启关键帧、添加参考图、设置比例、升级 1080P。原生音频提供同步音效。' },
      { num: '3', title: '生成、延长与下载', body: '生成含原生音频的视频；使用延长功能超过 8 秒。预览并下载所需质量。' }
    ],
  };
